// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__1wQfR","icon":"EnquiryForm_icon__3U6YO","heading":"EnquiryForm_heading__lOgF3","field":"EnquiryForm_field__GzPwa","error":"EnquiryForm_error__fHJ9o"};